import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export var FlowTranscribeVoiceTranscriptionType;
(function (FlowTranscribeVoiceTranscriptionType) {
    FlowTranscribeVoiceTranscriptionType["DICTATION"] = "DICTATION";
    FlowTranscribeVoiceTranscriptionType["CONVERSATION"] = "CONVERSATION";
})(FlowTranscribeVoiceTranscriptionType || (FlowTranscribeVoiceTranscriptionType = {}));
export const FlowVoiceTranscribeBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.VoiceTranscribe),
    config: z.object({
        storagePath: z.string(),
        transcriptionType: z.enum(FlowTranscribeVoiceTranscriptionType),
    }),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.VoiceTranscribe),
});
//# sourceMappingURL=config.js.map